(function(algolia) {
  'use strict';
  // Shopify Market Translations disabled for now
  // algolia.translations = {

  //   ...algolia.shopify.market.translations
  //   // Add additinonal translations here
  // };
  algolia.translations = {
    facets: null,
    sort_orders: null,
    addToCart: "Add to cart",
    allProducts: "See all products",
    articles: "Articles",
    by: "by",
    changeInput: "changing your input",
    clearAll: "Clear all",
    clearFilters: "clearing the filters",
    collections: "Collections",
    from: "From",
    in: "in",
    matching: "matching",
    noResultFor: "No result for",
    noResultFound: "No result found",
    oneResultFound: "1 result found",
    or: "or",
    outOf: "out of",
    outOfStock: "Out of stock",
    pages: "Pages",
    products: "Products",
    relevance: "Relevance",
    resultsFound: "results found",
    search: "Current search",
    searchForProduct: "Search for products",
    searchTitle: "Search result",
    selectedFilter: "Selected filters",
    showLess: "Show less",
    showMore: "Show more",
    sortBy: "Sort by",
    suggestions: "Suggestions",
    taxFree: "Tax Free",
    try: "Try",
  }

  algolia.translation_helpers = {
    no_result_for: function(text) {
      return `${algolia.translations.noResultFor} " ${text} ".`;
    },
    in: function(processingTimeMS) {
      return `${algolia.translations.in} ${processingTimeMS / 1000}s`;
    },

    outOf: function(page, hitsPerPage, nbHits) {
      return (
        page * hitsPerPage +
        1 +
        '-' +
        Math.min((page + 1) * hitsPerPage, nbHits) +
        ` ${ algolia.translations.outOf}`
      );
    },

    by: function(text) {
      if (!text) return '';
      return ` ${algolia.translations.by} ` + text;
    },

    render_title: function(text, query){
      if (text === 'Products' && query) {
        return text + ' for ' + query;
      }
      return text;
    }
  };
})(window.algoliasearch);
